module.exports = __webpack_public_path__ + "img/singpass.b38fa42c.png";